import React, { ReactNode } from 'react';
import { Icon, OverlayTrigger, PopOver } from '@tencent/spaui';

interface TooltipProps {
  popover: ReactNode;
  type?: 'info-filled' | 'question-filled' | null;
}

const Tooltip: React.FC<TooltipProps> = ({ popover, type, children }) => {
  if (!type) {
    return (
      <OverlayTrigger placement="top" overlay={<PopOver>{popover}</PopOver>}>
        {children}
      </OverlayTrigger>
    );
  }

  return (
    <div className="tooltip-container">
      {children}
      <OverlayTrigger placement="top" overlay={<PopOver>{popover}</PopOver>}>
        {<Icon name={type} className="tooltip" />}
      </OverlayTrigger>
    </div>
  );
};

Tooltip.defaultProps = {
  type: 'info-filled',
};

export default Tooltip;
